export class Tag
{
	tagId: number;
	tagDate?: Date;
	createDate?: Date;
	lastUpdate?: Date;
	name?: string;
	description?: string;
	tagType?: number;
	visibility?: number;
	tagGroupCategory?: string;

	// R3 — surfaced by the backend for the TagList page
	breezewayTagId?: number;
	tagColor?: string;          // hex like "#ff0000", inherited from category
	ownedByUserId?: number;
	ownedByUserName?: string;

	// R1 (Approach A) — direct OP→tag mapping. When this OP is added to a
	// reservation, this tag is auto-applied. NULL means "not auto-fired".
	orderProductId?: number;

	// R5 — payload of GET /tags/{id}/delete-preview (returned via tagService.deletePreview)
	// (Not stored on the row itself — separate response — but kept here for FE typing.)
}

/** Response body for GET /tags/{id}/delete-preview (R5). */
export interface TagDeletePreview
{
	tagId: number;
	tagName: string;
	reservationCount: number;
	folioMappingCount: number;
	childrenCount: number;
	breezewayTagId: number | null;
	canDelete: boolean;
}

/** Single entry from any of the three R7 history endpoints. */
export interface TagHistoryEntry
{
	action: 'added' | 'removed' | 'updated' | string;
	tagId?: number;
	tagName?: string;
	tagSource?: number;     // 90 = reservation, only set on usage feed when source is TagJoin
	tagSourceId?: number;   // resId or orderProductId, only set on usage feed
	entityType?: string;    // "TagJoinVO" or "FolioItemTagMappingVO" — only set on usage feed
	user?: string;
	timestamp?: string;     // ISO instant
}
